import { CheckCircleTwoTone } from '@ant-design/icons';
import { Button, List, Space } from 'antd';
import Alert, { AlertProps } from 'antd/es/alert';
import React, { useEffect, useState } from 'react';
import AsyncWrapper from '@/components/AsyncWrapper';
import Modal from '@/components/Modal';
import { Coupon, CouponStatus, useFetchCouponList } from '@/models/coupon';
import { playSound } from '@/utils/sound';
import { getCouponRuleDesc, getCouponTypeTag } from '@/utils/uiHelper';

interface Props {
  value?: Coupon;
  onChange?: (value: Coupon) => void;
  open: boolean;
  onCancel?: () => void;
  alert?: AlertProps;
}
const ModalSelector = ({ value: propValue, onChange, onCancel, open, alert }: Props) => {
  const { payload, send, loading, loaded, setPayload } = useFetchCouponList();
  const [value, setValue] = useState(propValue);

  useEffect(() => {
    if (open && !loaded) {
      send({ params: { status: CouponStatus.NORMAL, limit: 10 } });
    }
  }, [open, loaded]);

  useEffect(() => {
    setValue(propValue);
  }, [propValue]);

  return (
    <>
      <Modal
        title="选择优惠券"
        open={open}
        onCancel={onCancel}
        onOk={() => {
          onChange?.(value);
        }}>
        <AsyncWrapper loading={loading} render={loaded}>
          {() => {
            return (
              <div>
                {alert ? <Alert {...alert} /> : null}
                <List size={'large'}>
                  {payload.map(coupon => {
                    const checked = coupon.id === value?.id;
                    return (
                      <List.Item
                        key={coupon.id}
                        onClick={() => {
                          setValue(coupon);
                          playSound('click');
                        }}
                        actions={[
                          checked ? (
                            <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: 22 }} />
                          ) : (
                            <CheckCircleTwoTone twoToneColor={'#ccc'} style={{ fontSize: 22 }} />
                          ),
                        ]}>
                        <List.Item.Meta
                          avatar={getCouponTypeTag(coupon.couponType)}
                          title={
                            <Space>
                              <span>{coupon.name}</span>
                              <span className="text-gray">{getCouponRuleDesc(coupon)}</span>
                            </Space>
                          }
                          description={coupon.desc}
                        />
                      </List.Item>
                    );
                  })}
                </List>
              </div>
            );
          }}
        </AsyncWrapper>
      </Modal>
    </>
  );
};

export default ModalSelector;

export const CouponSelector = ({
  value,
  onChange,
}: Pick<Props, 'onChange'> & {
  value?: string | number;
  onChange?: (value: string | number) => void;
}) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<Coupon>();

  useEffect(() => {
    onChange(selected?.id);
  }, [selected]);

  return (
    <>
      <ModalSelector
        open={open}
        onCancel={() => {
          setOpen(false);
        }}
        onChange={v => {
          setSelected(v);
          setOpen(false);
        }}
      />
      <Button
        value={value}
        onClick={() => {
          setOpen(true);
        }}>
        {/* {value ? value.name : '未选择'} */}
        {selected ? selected.name : '未选择'}
      </Button>
    </>
  );
};
